module.exports = __webpack_public_path__ + "media/images/dashboard-e6379e8c80bfc30ba7849ce67e14172a.png";